import { IconButton } from "@/components/Button/IconButton";
import { ReverseLeftIcon } from "@/components/Icons/ReverseLeftIcon";
import { ReverseRightIcon } from "@/components/Icons/ReverseRightIcon";
import { Button } from "@/design-system/Button";
import { useBool } from "@/hooks/useBool";
import { useContentFieldManager } from "@/providers/ContentFieldProvider";
import { useTranslation } from "@/translations";

import { TicketAICopilotModal } from "./TicketAICopilotModal";

interface TicketCommentFieldAIActionsProps {
  ticketId: string;
}

export function TicketCommentFieldAIActions({ ticketId }: TicketCommentFieldAIActionsProps): React.ReactNode {
  const { t } = useTranslation();
  const [isCopilotModalOpened, copilotModalOpenHandlers] = useBool(false);

  const { currValue, isUndoable, isRedoable, onReplaceContent, onUndo, onRedo } = useContentFieldManager();

  return (
    <>
      <nav className="flex flex-1 shrink-0 flex-row flex-wrap gap-space-sm self-start">
        <Button variant="ai" data-testid="ticket-response-ai-button" onClick={copilotModalOpenHandlers.setTrue}>
          {isUndoable
            ? t("page.tickets.details.copilot.button.regenerate")
            : t("page.tickets.details.copilot.button.generate")}
        </Button>
        {(isUndoable || isRedoable) && (
          <>
            <IconButton
              variant="soft"
              disabled={!isUndoable}
              title={t("common.action.undo")}
              icon={<ReverseLeftIcon />}
              onClick={onUndo}
            />
            <IconButton
              variant="soft"
              disabled={!isRedoable}
              title={t("common.action.redo")}
              icon={<ReverseRightIcon />}
              onClick={onRedo}
            />
          </>
        )}
      </nav>
      <TicketAICopilotModal
        isOpened={isCopilotModalOpened}
        onOpenChange={copilotModalOpenHandlers.set}
        onGenerated={onReplaceContent}
        ticketId={ticketId}
        defaultInput={{ input: currValue }}
      />
    </>
  );
}
